import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import Layout from "../Layout";
import View from "../Components/Branding/View";
import EmpBrandingList from "../Components/Branding/EmpBrandingList";

function MyBranding() {
  const [comp, setComp] = useState("list");
  const [rowData, setRowData] = useState();
  const location = useLocation();
  const [currentOrder, setCurrentorder] = useState({});
  const [ismyBranding, setIsMyBranding] = useState(true);
  useEffect(() => {
    setComp("list");
  }, [location]);

  function handleChange(newValue) {
    setComp(newValue.mode);
    setRowData(newValue.rowData);
  }

  function renderComponent() {
    switch (comp) {
      case "list":
        return (
          <EmpBrandingList
            comp={comp}
            onChange={handleChange}
            rowData={rowData}
            setCurrentorder={setCurrentorder}
          />
        );
      case "view":
        return <View comp={comp} rowData={rowData} onChange={handleChange} ismyBranding={ismyBranding}/>;
    }
  }

  return (
    <Layout>
      <div className="main-content">
        <section className="section">
          <div className="section-header">
            <h1>My Branding</h1>
          </div>
          {renderComponent()}
        </section>
      </div>
    </Layout>
  );
}

export default MyBranding;
